export default __webpack_public_path__ + "static/media/cctv.b71e0d76.png";